import React from "react";
import PropTypes from "prop-types";
import { Paragraph } from "components/core/Typography";
import PSPMarkdownContent from "components/molecules/PSPMarkdown/PSPMarkdownContent";
import Pill from "components/atoms/Pill/Pill";

import "./ComparisonSection.scss";

export default function ComparisonSection(props) {
	const { sizes, postModuleDescription } = props;
	const defaultSize = sizes?.[0] || {};
	const [selectedSize, setSelectedSize] = React.useState(defaultSize);

	return (
		<div className="comparison-section-container">
			<div className="size-blocks-container">
				{sizes?.map((size) => (
					<Pill
						key={size.id}
						label={size.label}
						onClick={(e) => {
							e.stopPropagation();
							setSelectedSize(size);
						}}
						className={
							selectedSize?.id === size?.id ? "active" : ""
						}
						labelProps={{
							weight: "bold",
							size: "large",
							color: "black"
						}}
					/>
				))}
			</div>

			<div className="size-content-container">
				{sizes?.map((size) => {
					const isActive = selectedSize?.id === size?.id;
					return (
						<div
							key={size.id}
							className={`size-content-block ${
								isActive ? "active" : "hidden"
							}`}
							style={{ display: isActive ? "block" : "none" }}
						>
							{size.title && (
								<Paragraph
									size="xxlarge"
									weight="bold"
									color="black"
									className="size-content-title"
								>
									{size.title}
								</Paragraph>
							)}
							{size.description && (
								<PSPMarkdownContent
									content={size.description}
									additionalProps={{
										paragraph: {
											size: "standard",
											color: "black",
											style: { margin: 0 }
										}
									}}
								/>
							)}
						</div>
					);
				})}
			</div>
			{postModuleDescription && (
				<PSPMarkdownContent
					content={postModuleDescription}
					additionalProps={{
						paragraph: {
							size: "standard",
							color: "black",
							style: { padding: 0, margin: 0 }
						}
					}}
				/>
			)}
		</div>
	);
}

ComparisonSection.propTypes = {
	postModuleDescription: PropTypes.string,
	sizes: PropTypes.arrayOf(
		PropTypes.shape({
			id: PropTypes.string.isRequired,
			label: PropTypes.string.isRequired,
			title: PropTypes.string,
			description: PropTypes.string
		})
	)
};

ComparisonSection.defaultProps = {
	postModuleDescription: "",
	sizes: []
};
